<script>
// Path: src\layouts\TheDefaultLayout.vue

import { defineComponent } from "vue";
import WindowTray from "../../components/core/WindowTray.vue";

export default defineComponent({
    name: "TheDefaultLayout",
    components: { WindowTray }
});
</script>

<template>
  <div class="surface-card p-4 shadow-2 border-round m-5">
    <router-view />
  </div>
  <window-tray @minimize-window="minWindow" />
</template>
